import React, {useContext, useEffect} from 'react';
import {authContext} from '../../Context/Authentication/authContext';
import {generateMetroPopupContent} from '../../HeatMap/Components/utls';
import {getGeoJSONCenter} from '../../Helpers/helpers'
import '../../HeatMap/Components/Map/Map.scss'

declare const google: any;


const MapChart = (props: any) => {
  const {state, dispatch}: any = useContext(authContext);
  useEffect(() => {
    let popup: any = null
    const listeners: any[] = []
    const {geoData, msa} = props

    const map = new google.maps.Map(document.getElementById('metro-map'), {
      zoom: 8,
      mapTypeControl: false,
      streetViewControl: false,
      mapTypeControlOptions: {
        mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'tehgrayz']
      },
      restriction: {
        strictBounds: false,
      },
    });

    const stylez = [
      {
        featureType: 'all',
        elementType: 'all',
        stylers: [
          { saturation: -100 } // <-- THIS
        ]
      }
    ];
    const mapType = new google.maps.StyledMapType(stylez, { name:'Grayscale' });
    map.mapTypes.set('tehgrayz', mapType);
    map.setMapTypeId('tehgrayz');


    for (let i = 0; i < geoData.length; i++) {
      const metroData = geoData[i]
      map.data.addGeoJson(metroData)
    }

    map.data.setStyle(() => {
      return {
        // @ts-ignore
        fillColor: '#008CCA',
        strokeWeight: 1,
        fillOpacity: 0.7
      }
    });

    popup = new google.maps.InfoWindow()
    const listener = map.data.addListener('mouseover', (event: { latLng: any; }) => {
      const htmlContent = generateMetroPopupContent(event, msa)
      popup.setContent(htmlContent)
      popup.setPosition(event.latLng)
      popup.open(map)
    })
    listeners.push(listener)

    const popupListener = google.maps.event.addListener(map, 'mouseout', function () {
      popup.close()
    });
    listeners.push(popupListener)

    const centre = getGeoJSONCenter(geoData)
    if (centre) {
      map.setCenter(new google.maps.LatLng(centre.centerLat, centre.centerLon))
    } else {
      map.setCenter(new google.maps.LatLng(state?.filters?.stateCord?.lat, state?.filters?.stateCord?.lng))
    }

  }, [props?.geoData]);

  return <div id='metro-map' style={{ height: '500px', width: '100%' }}></div>;
};

export default MapChart;
